import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { startCase } from 'lodash';
import { Button, PageTitle } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MatchDetails from '~/components/IdentityDisputes/MatchDetails';
import { MatchStatus } from '~/utils/const/identity';

const MatchDetail = () => {
  const params = useParams();
  const history = useHistory();
  const matchStatusLabel = MatchStatus[params.matchStatusId];

  return (
    <>
      <PageTitle
        action={
          <Button
            color="secondary"
            outline
            onClick={() => history.goBack()}
          >
            <FontAwesomeIcon icon="chevron-left" className="mr-2" />

            <span>Back</span>
          </Button>
        }
      >
        Match Details - {startCase(matchStatusLabel)}
      </PageTitle>

      <MatchDetails
        matchStatusId={+params.matchStatusId}
        sacwisPersonId={params.sacwisPersonId}
      />
    </>
  );
};

export default MatchDetail;
